import { render, staticRenderFns } from "./SkMealCoupon.vue?vue&type=template&id=31992447&"
import script from "./SkMealCoupon.vue?vue&type=script&lang=js&"
export * from "./SkMealCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports